module.exports = __webpack_public_path__ + "static/media/fishBetAmbiance.5a0d56f9.mp3";